import { isObjectEmpty } from '@rentivo/gatsby-core/src/utils/objects';
export const hasErrors = (errors) => (!isObjectEmpty(errors));
export const fieldErrorMessage = (errors, field) => (errors && errors[field] && errors[field].message) ? errors[field].message : null;
